var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconShopify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 32.65,
    viewBox: "0 0 29 32.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-shopify",
    "data-name": "Icon simple-shopify",
    d: "M21.394,32.65l9.778-2.115S27.643,6.668,27.615,6.51a.3.3,0,0,0-.286-.26c-.131,0-2.614-.184-2.614-.184s-1.728-1.726-1.95-1.912a.52.52,0,0,0-.164-.1l-1.239,28.6h.031ZM15.346,1.125a.91.91,0,0,1,.549.183c-1.333.63-2.8,2.221-3.4,5.409-.889.289-1.752.549-2.56.783.7-2.419,2.4-6.362,5.409-6.362Zm1.674,4V5.3c-1.022.314-2.145.656-3.244,1,.631-2.408,1.806-3.584,2.825-4.026A7.972,7.972,0,0,1,17.019,5.121Zm.73-3.027c.94.1,1.546,1.175,1.936,2.378-.473.154-1,.313-1.569.5V4.626a7.706,7.706,0,0,0-.367-2.535ZM21.8,3.84c-.027,0-.081.028-.106.028s-.392.1-.968.285c-.573-1.671-1.594-3.212-3.4-3.212h-.156A2.23,2.23,0,0,0,15.475,0c-4.209,0-6.22,5.254-6.85,7.922-1.618.495-2.8.862-2.927.913-.915.289-.94.314-1.046,1.179-.1.626-2.48,19.056-2.48,19.056l18.376,3.451L21.8,3.84Z",
    transform: "translate(-2.172)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShopify);
export default __webpack_public_path__ + "static/media/icon-shopify.33f64606ffc7443083f3181b81c042f1.svg";
export { ForwardRef as ReactComponent };